module.exports = __webpack_public_path__ + "static/media/Nile Buisness Tower Still 05.eb85e88c.webp";